import { styled, TableCell, tableCellClasses } from "@mui/material";
import { getColors } from "utils";

const StyledTableFormCells = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "maxWidth",
})(({ theme, maxWidth }) => {
  const colors = getColors(theme, "");
  const { lighter } = colors;

  return {
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: lighter,
      color: colors[600],
      zIndex: 12,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      height: 72,
      // padding: "26px 24px",
      padding: "0 10px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: maxWidth ?? 250,
      minWidth: 68,
      cursor: "default",
      color: theme.palette.text.secondary,
    },
    [`&.${tableCellClasses.footer}`]: {
      backgroundColor: "#ffffff",
      color: colors[600],
      padding: "10px 15px",
      position: "sticky",
      bottom: -1,
      borderTop: "1px solid #dcdee0",
      borderBottom: "0px solid #dcdee0",
      zIndex: 12,
    },
    [`&.${tableCellClasses.paddingCheckbox}`]: {
      // paddingLeft: 12,
      // paddingRight: 0,
      padding: "13px 0 13px 12px",
    },
  };
});

export default StyledTableFormCells;
